import { queryOptions } from '@tanstack/react-query'

import { Lang } from '@/api/generated-api-and-types'

import { createApiMethod, type } from './utils/createApiMethod'

export const locale = {
  detect: createApiMethod({
    method: 'GET',
    path: '/lang',
    response: type<Lang>(),
  }),
}

export const localeQueries = {
  all: () => ['locale'] as const,
  detect: () =>
    queryOptions({
      queryKey: [...localeQueries.all(), 'detect'] as const,
      queryFn: () => locale.detect(),
      // Language detection is stable for the session.
      staleTime: Infinity,
    }),
}
